import React from "react";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import Tag from "../../../../components/Tag";
import { closeModalAction, openModalAction } from "../../../../components/Modal/reducer";
import { MODAL_EXPORT_LOADING } from "../../../../components/SmartTable/ExportDropdown/LoadingModal";
import { downloadFile } from "../../../../utils/downloadFile";
import { openNotification } from "../../../../components/Notification";
import { computeFileNameExtension, getExtensionLabelClassName } from "./methods";

const FileBox = ({ className, filename, fileUrl, fileExt, downloadIcon, onRemove }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fileExtension = fileExt || (filename ? filename.substr(filename.lastIndexOf(".") + 1) : null);
  const extUppercase = fileExtension ? fileExtension.toUpperCase() : null;
  const extClass = getExtensionLabelClassName(extUppercase);

  const download = () => {
    if (!fileUrl) return;
    dispatch(openModalAction({ name: MODAL_EXPORT_LOADING }));
    downloadFile({
      fileUrl: fileUrl,
      fileName: computeFileNameExtension(filename, extUppercase),
      onSuccess: () => {
        dispatch(closeModalAction({ name: MODAL_EXPORT_LOADING }));
      },
      onFailed: () => {
        openNotification({ type: "error", message: t("container.form_errors.internal_server_error") });
        dispatch(closeModalAction({ name: MODAL_EXPORT_LOADING }));
      }
    });
  };

  const isOuterClickable = !downloadIcon && !!fileUrl;

  const content = (
    <>
      <div className="file-box-name-ext">
        {extUppercase && <Tag className={classNames("file-extension mr-5", extClass)}>{extUppercase}</Tag>}
        {filename && <span className="file-name">{filename}</span>}
      </div>
      {(downloadIcon || onRemove) && (
        <div className="actions">
          {downloadIcon && fileUrl && (
            <Tooltip title={t("container.general_words.download")}>
              <button
                type="button"
                className="action-item"
                onClick={download}
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              >
                {downloadIcon}
              </button>
            </Tooltip>
          )}
          {onRemove && (
            <Tooltip title={t("container.general_words.delete")} className="text-danger">
              <button
                type="button"
                className="action-item"
                onClick={onRemove}
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              >
                <i className="ti-close text-danger" />
              </button>
            </Tooltip>
          )}
        </div>
      )}
    </>
  );

  const containerClassName = classNames("file-box", className, {
    clickable: !!fileUrl && !downloadIcon,
    "with-download": downloadIcon,
    "with-delete": onRemove
  });

  if (isOuterClickable) {
    return (
      <button
        type="button"
        className={containerClassName}
        onClick={download}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left" }}
      >
        {content}
      </button>
    );
  }

  return <div className={containerClassName}>{content}</div>;
};

export default FileBox;
